<template>
    <v-layout column fill-height>
        <breadcrumbs guia="Processos Judiciais" titulo="Processos Judiciais" descricao="Gerencie e acompanhe os processos de seus clientes." />

        <v-layout class="main">
            <processos />
        </v-layout>

    </v-layout>
</template>


<script>
import breadcrumbs from "@/components/portal/layout/Breadcrumbs";

import processos from "@/components/portal/processos-judiciais/Processos";


export default {
  components: {
    breadcrumbs,
    processos
  },
};
</script>